import gql from "graphql-tag";
import PinnablePostFields from "../../fragments/engagement/PinnablePostFields";

export default gql`
  mutation UnpinPost($objectId: ID!) {
    unpinPost(objectId: $objectId) {
      ...PinnablePostFields
    }
  }

  ${PinnablePostFields}
`;
